import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { annoncesAPI, isLoggedIn, getUser } from '../api';
import '../App.css';

function HomePage() {
  const navigate = useNavigate();
  const user = getUser();
  const [annonces, setAnnonces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeType, setActiveType] = useState('Automobile');
  const [delai, setDelai] = useState('express');

  useEffect(() => {
    fetchAnnonces();
  }, []);

  const fetchAnnonces = async () => {
    try {
      const res = await annoncesAPI.getAll({ limit: 6, page: 1 });
      setAnnonces(res.data.annonces || []);
    } catch (err) {
      console.error('Erreur chargement annonces:', err);
    } finally {
      setLoading(false);
    }
  };

  const getFirstPhoto = (photos) => {
    try {
      if (!photos) return null;
      const list = typeof photos === 'string' ? JSON.parse(photos) : photos;
      return list && list.length > 0 ? list[0] : null;
    } catch (e) {
      return null;
    }
  };

  const zones = {
    ville: { urgent: 2000, express: 1500, normal: 1000 },
    region: { urgent: 3500, express: 2500, normal: 1500 },
    national: { urgent: 6000, express: 4500, normal: 3000 },
  };

  return (
    <div className="app">

      {/* NAV */}
      <nav className="nav">
        <div className="logo-wrap">
          <div className="logo">Tek<span>Teck</span></div>
          <div className="logo-tag">rak tak!</div>
        </div>
        <div className="nav-links">
          <Link to="/catalogue">Catalogue</Link>
          <a href="#how">Comment ca marche</a>
          <Link to="/deposer-annonce">Vendre</Link>
        </div>
        <div className="nav-actions">
          {isLoggedIn() ? (
            <>
              <span style={{ fontSize: '13px', color: '#888' }}>Bonjour {user?.prenom} !</span>
              <Link to={user?.role === 'vendeur' ? '/vendeur' : user?.role === 'admin' ? '/admin' : '/mon-compte'}>
                <button className="btn-ghost">Mon espace</button>
              </Link>
            </>
          ) : (
            <Link to="/connexion"><button className="btn-ghost">Se connecter</button></Link>
          )}
          <Link to="/deposer-annonce"><button className="btn-orange">Vendre mes pieces</button></Link>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-glow" />
        <div className="hero-glow2" />
        <div className="hero-grid">

          {/* COLONNE GAUCHE */}
          <div>
            <div className="hero-pill">
              <span className="blink" />
              AUTO · CAMION · MOTO · MACHINE
            </div>
            <h1>
              LA PIÈCE<br />
              <span className="orange">QU'IL VOUS</span><br />
              FAUT.
              <span className="rak">RAK TAK !</span>
            </h1>
            <p className="hero-sub">
              Achetez et vendez des pièces détachées neuves et d'occasion.<br />
              <strong>Livraison en 2h, 4h ou 8h</strong> dans toute la region.
            </p>
            <div className="hero-ctas">
              <Link to="/catalogue"><button className="btn-hero">Parcourir le catalogue</button></Link>
              <Link to="/deposer-annonce"><button className="btn-hero-out">Devenir vendeur</button></Link>
            </div>

            {/* STATS */}
            <div className="hero-stats">
              {[
                { val: '48K+', label: 'Pieces disponibles' },
                { val: '1200+', label: 'Vendeurs verifies' },
                { val: '3', label: 'Options livraison' },
                { val: '2H', label: 'Livraison min.' },
              ].map((s, i) => (
                <div key={i}>
                  <div className="stat-n">{s.val}</div>
                  <div className="stat-l">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* COLONNE DROITE — PANNEAU */}
          <div className="hero-panel">
            <div className="panel-head">DERNIERES ANNONCES</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>⏳ Chargement...</div>
              ) : annonces.slice(0, 3).map(a => {
                const firstPhoto = getFirstPhoto(a.photos);
                return (
                  <Link key={a.id} to={`/produit/${a.id}`} style={{ textDecoration: 'none' }}>
                    <div className="panel-card">
                      <div className="pc-top">
                        <span className="pc-cat">{a.type_vehicule?.toUpperCase()} · {a.categorie?.toUpperCase()}</span>
                        <span className={`pc-badge ${a.etat === 'Neuf' ? 'pb-new' : 'pb-used'}`}>{a.etat}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ width: '44px', height: '44px', borderRadius: '6px', overflow: 'hidden', background: '#2A2A2A', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {firstPhoto ? (
                            <img src={firstPhoto} alt={a.nom_piece} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : (
                            <span style={{ fontSize: '18px' }}>🔧</span>
                          )}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="pc-name">{a.nom_piece}</div>
                          <div className="pc-price">{parseInt(a.prix).toLocaleString('fr-FR')} <sub>FCFA</sub></div>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>

            {/* LIVRAISON */}
            <div className="panel-head">CHOISIR LA LIVRAISON</div>
            <div className="panel-livraison">
              {[
                { key: 'urgent', icon: '⚡', label: 'Urgent 2h', price: zones.ville.urgent },
                { key: 'express', icon: '🚀', label: 'Express 4h', price: zones.ville.express },
                { key: 'normal', icon: '📦', label: 'Normal 8h', price: zones.ville.normal },
              ].map(d => (
                <div key={d.key} onClick={() => setDelai(d.key)} className={`liv-chip ${delai === d.key ? 'active' : ''}`}>
                  <span className="ico">{d.icon}</span>
                  <span className="dur">{d.label}</span>
                  <span className="prix">{d.price.toLocaleString('fr-FR')} F</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* TYPES VEHICULES */}
      <section style={{ padding: '48px', background: '#141414' }}>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', letterSpacing: '1px', color: '#fff', marginBottom: '24px', textAlign: 'center' }}>
          PIECES POUR TOUS VOS <span style={{ color: '#F5620A' }}>VEHICULES</span>
        </div>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '32px', flexWrap: 'wrap' }}>
          {[
            { type: 'Automobile', icon: '🚗', desc: 'Voitures & SUV' },
            { type: 'Camion', icon: '🚚', desc: 'Poids lourds' },
            { type: 'Moto', icon: '🏍️', desc: 'Motos & scooters' },
            { type: 'Machine', icon: '⚙️', desc: 'Engins & machines' },
          ].map(v => (
            <div key={v.type} onClick={() => { setActiveType(v.type); navigate(`/catalogue?type=${v.type}`); }}
              style={{
                background: activeType === v.type ? '#F5620A' : '#1C1C1C',
                border: `1px solid ${activeType === v.type ? '#F5620A' : '#333'}`,
                borderRadius: '12px', padding: '20px 28px', cursor: 'pointer',
                textAlign: 'center', transition: 'all .2s', minWidth: '140px'
              }}>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>{v.icon}</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '16px', letterSpacing: '1px', color: '#fff' }}>{v.type}</div>
              <div style={{ fontSize: '11px', color: activeType === v.type ? 'rgba(255,255,255,.8)' : '#888', marginTop: '4px' }}>{v.desc}</div>
            </div>
          ))}
        </div>

        {/* ANNONCES PAR TYPE */}
        <div className="prod-grid">
          {loading ? (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', color: '#888' }}>⏳ Chargement...</div>
          ) : annonces.length === 0 ? (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px', color: '#888' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', color: '#fff', marginBottom: '8px' }}>AUCUNE ANNONCE</div>
              <Link to="/deposer-annonce"><button className="btn-orange">Deposer la premiere annonce</button></Link>
            </div>
          ) : annonces.map(a => {
            const firstPhoto = getFirstPhoto(a.photos);
            return (
              <Link key={a.id} to={`/produit/${a.id}`} style={{ textDecoration: 'none' }}>
                <div className="pcard">
                  <div className="pimg">
                    {firstPhoto ? (
                      <img src={firstPhoto} alt={a.nom_piece} style={{ width: '100%', height: '145px', objectFit: 'cover', display: 'block' }} onError={e => e.target.style.display = 'none'} />
                    ) : (
                      <div className="pimg-icon">🔧</div>
                    )}
                    <span className={`pbadge ${a.etat === 'Neuf' ? 'pb-n' : 'pb-u'}`}>{a.etat}</span>
                  </div>
                  <div className="pbody">
                    <div className="pcat">{a.type_vehicule?.toUpperCase()} · {a.categorie?.toUpperCase()}</div>
                    <div className="pname">{a.nom_piece}</div>
                    <div className="pfoot">
                      <div className="pprice">{parseInt(a.prix).toLocaleString('fr-FR')} <sub>FCFA</sub></div>
                      <button className="padd">🛒</button>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <Link to="/catalogue"><button className="btn-orange">Voir toutes les annonces →</button></Link>
        </div>
      </section>

      {/* COMMENT CA MARCHE */}
      <section id="how" className="how">
        <div className="how-top">
          <span className="how-tag">SIMPLE & RAPIDE</span>
          <h2>COMMENT CA <span style={{ color: '#F5620A' }}>MARCHE</span> ?</h2>
        </div>
        <div className="how-grid">
          {[
            { step: '01', icon: '🔍', title: 'Trouvez la piece', desc: 'Recherchez parmi des milliers de pieces disponibles' },
            { step: '02', icon: '💳', title: 'Payez en securite', desc: 'Paiement Mobile Money securise — Wave, Orange, Free' },
            { step: '03', icon: '🛵', title: 'Livraison rapide', desc: 'Votre piece livree en 2h, 4h ou 8h' },
            { step: '04', icon: '✅', title: 'Confirmez', desc: 'Validez la reception et liberez le paiement au vendeur' },
          ].map((s, i) => (
            <div key={i} className="how-item">
              <div className="how-num">{s.step}</div>
              <div className="how-ico">{s.icon}</div>
              <div className="how-t">{s.title}</div>
              <div className="how-d">{s.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA VENDEUR */}
      <div className="sell">
        <div>
          <h3>VOUS AVEZ DES PIECES <span>A VENDRE</span> ?</h3>
          <p className="sell-sub">
            Rejoignez TekTeck et vendez vos pieces detachees a des milliers d'acheteurs. Commission 5% seulement. Paiement garanti.
          </p>
          <div className="perks">
            <div className="perk"><span className="perk-dot" />Commission 5% seulement</div>
            <div className="perk"><span className="perk-dot" />Paiement garanti</div>
            <div className="perk"><span className="perk-dot" />Livraison prise en charge</div>
          </div>
        </div>
        <Link to="/deposer-annonce">
          <button className="btn-sell">Deposer une annonce gratuitement →</button>
        </Link>
      </div>

      {/* FOOTER */}
      <footer>
        <div className="footer-bottom">
          <div>
            <span className="footer-logo">Tek<span>Teck</span></span>
            <div className="footer-tag">rak tak!</div>
          </div>
          <span style={{ color: '#666', fontSize: '12px' }}>2025 TekTeck · <span className="footer-domain">tekteck.com</span> · Confidentialite · CGU</span>
        </div>
      </footer>

    </div>
  );
}

export default HomePage;